import { ICheckoutOrderDiscountResource, OrderDiscountType } from "JS/types/Checkout";
import { OfferDisplayType } from "JS/helpers/promo-helpers";

export function getOfferDisplayTypeFromCheckoutOrderDiscount(discount: ICheckoutOrderDiscountResource): OfferDisplayType {
	switch (discount.discountType) {
		case OrderDiscountType.General:
			return 'normal';
		case OrderDiscountType.Rewards:
			return 'rewards';
		case OrderDiscountType.FreeItem:
			return 'freeitem';
		case OrderDiscountType.GiftCard:
			return 'giftcard';
		case OrderDiscountType.Shipping:
			return 'shipping';
		case OrderDiscountType.Delivery:
			return 'delivery';
	}
}
